export default "__VITE_ASSET__Hqbe9ODS__"